import client from './client';

/**
 * 요청수 통계
 */
export const requestStatistics = (param) =>
  client.get(`/api/report/request`, param);

/**
 * 요청수 통계 - 그래프
 */
export const requestGraph = (param) =>
  client.get(`/api/report/request/graph`, { params: param });

/**
 * 지면별 타게팅분포
 */
export const requestMcTargetStatistics = (param) =>
  client.get(`/api/report/request/mctarget`, param);

/**
 * 지면별 타게팅분포 - 그래프
 */
export const requestMCGraph = (param) =>
  client.get(`/api/report/request/mcgraph`, { params: param });
